$(function () {
    $("#2022-standard").click(function () {
      if ($(".2022-standard").is(":visible")){
        if ($(".2022-datacenter").is(":visible")){
          if($("#2022").prop("disabled")){
            $("#2022-datacenter").prop("checked") && $("#2022-datacenter").prop("disabled", true);
          }
          $(".column-2022.column-header").attr('colspan', 1);
          $(".2022-standard").hide();
        } else {
          $("#2022").prop("checked", false);
          $(".column-2022.column-header").attr('colspan', 1);
          $(".column-2022").hide();
          toggleTableView();
        }
      } else {
        if ($(".2022-datacenter").is(":visible")){
          if($("#2022").prop("disabled")){
            $("#2022-datacenter").prop("checked") && $("#2022-datacenter").prop("disabled", false);
          }
          $(".column-2022.column-header").attr('colspan', 2);
          $(".2022-standard").show();
        } else {
          $("#2022").prop("checked", true);
          $(".column-2022.column-header").show();
          $(".column-2022.column-header").attr('colspan', 1);
          $(".2022-standard").show();
          toggleTableView();
        }
      }
    });
    $("#2022-datacenter").click(function () {
      if ($(".2022-datacenter").is(":visible")){
        if ($(".2022-standard").is(":visible")){
          if($("#2022").prop("disabled")){
            $("#2022-standard").prop("checked") && $("#2022-standard").prop("disabled", true);
          }
          $(".column-2022.column-header").attr('colspan', 1);
          $(".2022-datacenter").hide();
        } else {
          $("#2022").prop("checked", false);
          $(".column-2022.column-header").attr('colspan', 1);
          $(".column-2022").hide();
          toggleTableView();
        }
      } else {
        if ($(".2022-standard").is(":visible")){
          if($("#2022").prop("disabled")){
            $("#2022-standard").prop("checked") && $("#2022-standard").prop("disabled", false);
          }
          $(".column-2022.column-header").attr('colspan', 2);
          $(".2022-datacenter").show();
        } else {
          $("#2022").prop("checked", true);
          $(".column-2022.column-header").show();
          $(".column-2022.column-header").attr('colspan', 1);
          $(".2022-datacenter").show();
          toggleTableView();
        }
      }
    });
    $("#2019-standard").click(function () {
      if ($(".2019-standard").is(":visible")){
        if ($(".2019-datacenter").is(":visible")){
          if ($(".2019-essentials").is(":visible")){
            $(".column-2019.column-header").attr('colspan', 2);
            $(".2019-standard").hide();
          } else {
            if($("#2019").prop("disabled")){
              $("#2019-datacenter").prop("disabled", true);
            }
            $(".column-2019.column-header").attr('colspan', 1);
            $(".2019-standard").hide();
          }
        } else {
          if ($(".2019-essentials").is(":visible")){
            if($("#2019").prop("disabled")){
              $("#2019-essentials").prop("disabled", true);
            }
            $(".column-2019.column-header").attr('colspan', 1);
            $(".2019-standard").hide();
          } else {
            $("#2019").prop("checked", false);
            $(".column-2019.column-header").attr('colspan', 1);
            $(".column-2019").hide();
            toggleTableView();
          }
        }
      } else {
        if ($(".2019-datacenter").is(":visible")){
          if ($(".2019-essentials").is(":visible")){
            $(".column-2019.column-header").attr('colspan', 3);
            $(".2019-standard").show();
          } else {
            $(".column-2019.column-header").attr('colspan', 2);
            $(".2019-standard").show();
          }
        } else {
          if ($(".2019-essentials").is(":visible")){
            $(".column-2019.column-header").attr('colspan', 2);
            $(".2019-standard").show();
          } else {
            $("#2019").prop("checked", true);
            $(".column-2019.column-header").show();
            $(".column-2019.column-header").attr('colspan', 1);
            $(".2019-standard").show();
            toggleTableView();
          }
        }
      }
    });
    $("#2019-datacenter").click(function () {
      if ($(".2019-datacenter").is(":visible")){
        if ($(".2019-standard").is(":visible")){
          if ($(".2019-essentials").is(":visible")){
            $(".column-2019.column-header").attr('colspan', 2);
            $(".2019-datacenter").hide();
          } else {
            if($("#2019").prop("disabled")){
              $("#2019-standard").prop("disabled", true);
            }
            $(".column-2019.column-header").attr('colspan', 1);
            $(".2019-datacenter").hide();
          }
        } else {
          if ($(".2019-essentials").is(":visible")){
            if($("#2019").prop("disabled")){
              $("#2019-essentials").prop("disabled", true);
            }
            $(".column-2019.column-header").attr('colspan', 1);
            $(".2019-datacenter").hide();
          } else {
            $("#2019").prop("checked", false);
            $(".column-2019.column-header").attr('colspan', 1);
            $(".column-2019").hide();
            toggleTableView();
          }
        }
      } else {
        if ($(".2019-standard").is(":visible")){
          if ($(".2019-essentials").is(":visible")){
            $(".column-2019.column-header").attr('colspan', 3);
            $(".2019-datacenter").show();
          } else {
            $(".column-2019.column-header").attr('colspan', 2);
            $(".2019-datacenter").show();
          }
        } else {
          if ($(".2019-essentials").is(":visible")){
            $(".column-2019.column-header").attr('colspan', 2);
            $(".2019-datacenter").show();
          } else {
            $("#2019").prop("checked", true);
            $(".column-2019.column-header").show();
            $(".column-2019.column-header").attr('colspan', 1);
            $(".2019-datacenter").show();
            toggleTableView();
          }
        }
      }
    });
    $("#2019-essentials").click(function () {
      if ($(".2019-essentials").is(":visible")){
        if ($(".2019-datacenter").is(":visible")){
          if ($(".2019-standard").is(":visible")){
            $(".column-2019.column-header").attr('colspan', 2);
            $(".2019-essentials").hide();
          } else {
            if($("#2019").prop("disabled")){
              $("#2019-datacenter").prop("disabled", true);
            }
            $(".column-2019.column-header").attr('colspan', 1);
            $(".2019-essentials").hide();
          }
        } else {
          if ($(".2019-standard").is(":visible")){
            if($("#2019").prop("disabled")){
              $("#2019-standard").prop("disabled", true);
            }
            $(".column-2019.column-header").attr('colspan', 1);
            $(".2019-essentials").hide();
          } else {
            $("#2019").prop("checked", false);
            $(".column-2019.column-header").attr('colspan', 1);
            $(".column-2019").hide();
            toggleTableView();
          }
        }
      } else {
        if ($(".2019-datacenter").is(":visible")){
          if ($(".2019-standard").is(":visible")){
            $(".column-2019.column-header").attr('colspan', 3);
            $(".2019-essentials").show();
          } else {
            $(".column-2019.column-header").attr('colspan', 2);
            $(".2019-essentials").show();
          }
        } else {
          if ($(".2019-standard").is(":visible")){
            $(".column-2019.column-header").attr('colspan', 2);
            $(".2019-essentials").show();
          } else {
            $("#2019").prop("checked", true);
            $(".column-2019.column-header").show();
            $(".column-2019.column-header").attr('colspan', 1);
            $(".2019-essentials").show();
            toggleTableView();
          }
        }
      }
    });
    $("#2016-standard").click(function () {
        if ($(".2016-standard").is(":visible")){
          if ($(".2016-datacenter").is(":visible")){
            if ($(".2016-essentials").is(":visible")){
              $(".column-2016.column-header").attr('colspan', 2);
              $(".2016-standard").hide();
            } else {
              if($("#2016").prop("disabled")){
                $("#2016-datacenter").prop("disabled", true);
              }
              $(".column-2016.column-header").attr('colspan', 1);
              $(".2016-standard").hide();
            }
          } else {
            if ($(".2016-essentials").is(":visible")){
              if($("#2016").prop("disabled")){
                $("#2016-essentials").prop("disabled", true);
              }
              $(".column-2016.column-header").attr('colspan', 1);
              $(".2016-standard").hide();
            } else {
              $("#2016").prop("checked", false);
              $(".column-2016.column-header").attr('colspan', 1);
              $(".column-2016").hide();
              toggleTableView();
            }
          }
        } else {
          if ($(".2016-datacenter").is(":visible")){
            if ($(".2016-essentials").is(":visible")){
              $(".column-2016.column-header").attr('colspan', 3);
              $(".2016-standard").show();
            } else {
              $(".column-2016.column-header").attr('colspan', 2);
              $(".2016-standard").show();
            }
          } else {
            if ($(".2016-essentials").is(":visible")){
              $(".column-2016.column-header").attr('colspan', 2);
              $(".2016-standard").show();
            } else {
              $("#2016").prop("checked", true);
              $(".column-2016.column-header").show();
              $(".column-2016.column-header").attr('colspan', 1);
              $(".2016-standard").show();
              toggleTableView();
            }
          }
        }
      });
      $("#2016-datacenter").click(function () {
        if ($(".2016-datacenter").is(":visible")){
          if ($(".2016-standard").is(":visible")){
            if ($(".2016-essentials").is(":visible")){
              $(".column-2016.column-header").attr('colspan', 2);
              $(".2016-datacenter").hide();
            } else {
              if($("#2016").prop("disabled")){
                $("#2016-standard").prop("disabled", true);
              }
              $(".column-2016.column-header").attr('colspan', 1);
              $(".2016-datacenter").hide();
            }
          } else {
            if ($(".2016-essentials").is(":visible")){
              if($("#2016").prop("disabled")){
                $("#2016-essentials").prop("disabled", true);
              }
              $(".column-2016.column-header").attr('colspan', 1);
              $(".2016-datacenter").hide();
            } else {
              $("#2016").prop("checked", false);
              $(".column-2016.column-header").attr('colspan', 1);
              $(".column-2016").hide();
              toggleTableView();
            }
          }
        } else {
          if ($(".2016-standard").is(":visible")){
            if ($(".2016-essentials").is(":visible")){
              $(".column-2016.column-header").attr('colspan', 3);
              $(".2016-datacenter").show();
            } else {
              $(".column-2016.column-header").attr('colspan', 2);
              $(".2016-datacenter").show();
            }
          } else {
            if ($(".2016-essentials").is(":visible")){
              $(".column-2016.column-header").attr('colspan', 2);
              $(".2016-datacenter").show();
            } else {
              $("#2016").prop("checked", true);
              $(".column-2016.column-header").show();
              $(".column-2016.column-header").attr('colspan', 1);
              $(".2016-datacenter").show();
              toggleTableView();
            }
          }
        }
      });
      $("#2016-essentials").click(function () {
        if ($(".2016-essentials").is(":visible")){
          if ($(".2016-datacenter").is(":visible")){
            if ($(".2016-standard").is(":visible")){
              $(".column-2016.column-header").attr('colspan', 2);
              $(".2016-essentials").hide();
            } else {
              if($("#2016").prop("disabled")){
                $("#2016-datacenter").prop("disabled", true);
              }
              $(".column-2016.column-header").attr('colspan', 1);
              $(".2016-essentials").hide();
            }
          } else {
            if ($(".2016-standard").is(":visible")){
              if($("#2016").prop("disabled")){
                $("#2016-standard").prop("disabled", true);
              }
              $(".column-2016.column-header").attr('colspan', 1);
              $(".2016-essentials").hide();
            } else {
              $("#2016").prop("checked", false);
              $(".column-2016.column-header").attr('colspan', 1);
              $(".column-2016").hide();
              toggleTableView();
            }
          }
        } else {
          if ($(".2016-datacenter").is(":visible")){
            if ($(".2016-standard").is(":visible")){
              $(".column-2016.column-header").attr('colspan', 3);
              $(".2016-essentials").show();
            } else {
              $(".column-2016.column-header").attr('colspan', 2);
              $(".2016-essentials").show();
            }
          } else {
            if ($(".2016-standard").is(":visible")){
              $(".column-2016.column-header").attr('colspan', 2);
              $(".2016-essentials").show();
            } else {
              $("#2016").prop("checked", true);
              $(".column-2016.column-header").show();
              $(".column-2016.column-header").attr('colspan', 1);
              $(".2016-essentials").show();
              toggleTableView();
            }
          }
        }
      });
    $("#select-all").click(function () {
      $("#2022").prop("checked", true);
      $("#2019").prop("checked", true);
      $("#2016").prop("checked", true);

      $("#2022-standard").prop("checked", true);
      $("#2022-datacenter").prop("checked", true);
      $("#2019-standard").prop("checked", true);
      $("#2019-datacenter").prop("checked", true);
      $("#2019-essentials").prop("checked", true);
      $("#2016-standard").prop("checked", true);
      $("#2016-datacenter").prop("checked", true);
      $("#2016-essentials").prop("checked", true);

      $(".column-2022.column-header").attr('colspan', 2);
      $(".column-2022").show();
      $(".column-2019.column-header").attr('colspan', 3);
      $(".column-2019").show();
      $(".column-2016.column-header").attr('colspan', 3);
      $(".column-2016").show();

      toggleTableView();
    });
    $("#select-none").click(function () {
      $("#2022").prop("checked", false);
      $("#2019").prop("checked", false);
      $("#2016").prop("checked", false);

      $("#2022-standard").prop("checked", false);
      $("#2022-datacenter").prop("checked", false);
      $("#2019-standard").prop("checked", false);
      $("#2019-datacenter").prop("checked", false);
      $("#2019-essentials").prop("checked", false);
      $("#2016-standard").prop("checked", false);
      $("#2016-datacenter").prop("checked", false);
      $("#2016-essentials").prop("checked", false);

      $(".column-2022").hide();
      $(".column-2019").hide();
      $(".column-2016").hide();



      toggleTableView();
    });
    $(".matrix-toggles").show();
});

  function uncheckToggle(toggle){
    if ($(toggle).prop("checked") == true) {
      $(toggle).click();
    }
  }
  function checkToggle(toggle){
    if ($(toggle).prop("checked") == false) {
      $(toggle).click();
    }
  }

  function toggleGroup(group){
    if (group == '2022') {
      if ($("#2022").prop("checked") == false) {
        uncheckToggle("#2022-standard");
        uncheckToggle("#2022-datacenter");
      } else {
        checkToggle("#2022-standard");
        checkToggle("#2022-datacenter");
      }
    } else if (group == '2019') {
      if ($("#2019").prop("checked") == false) {
        uncheckToggle("#2019-standard");
        uncheckToggle("#2019-datacenter");
        uncheckToggle("#2019-essentials");
      } else {
        checkToggle("#2019-standard");
        checkToggle("#2019-datacenter");
        checkToggle("#2019-essentials");
      }
    } else if (group == '2016') {
      if ($("#2016").prop("checked") == false) {
        uncheckToggle("#2016-standard");
        uncheckToggle("#2016-datacenter");
        uncheckToggle("#2016-essentials");
      } else {
        checkToggle("#2016-standard");
        checkToggle("#2016-datacenter");
        checkToggle("#2016-essentials");
      }
    }
  }

  function toggleTableView(){
    if (($("#2022").prop("checked") == false) && ($("#2019").prop("checked") == false) && ($("#2016").prop("checked") == false)){
        $('#table-container').hide();
        $('#table-container-error').show();
    } else {
        $('#table-container-error').hide();
        $('#table-container').show();
    }
  }

  